import type { SaasPlanDto } from './api'
import plan6 from '../assets/plan-6-months.jpg'
import plan12 from '../assets/plan-1-year.jpg'
import plan24 from '../assets/plan-2-years.jpg'

const byMonths: Record<number, string> = {
  6: plan6,
  12: plan12,
  24: plan24,
}

/** Prefer DB-backed image URL; fall back to bundled assets. */
export function planImageSrc(plan: Pick<SaasPlanDto, 'imageUrl' | 'commitmentMonths'>): string {
  if (plan.imageUrl) {
    return plan.imageUrl
  }
  return byMonths[plan.commitmentMonths] ?? plan12
}
